import fetch from '@/utils/fetch'

// 列表接口
export const url = '/tradein-tcb/orders/list'

/**
 * 导出旧机回收订单
 */
export function exportOldPhoneRecycle(params) {
  return fetch({
    url: url,
    method: 'get',
    params,
  })
}
